// extracted by mini-css-extract-plugin
export default {"step_area":"Step_step_area__pIv5J","contents":"Step_contents__cDdP0","vanta":"Step_vanta__gjBNF"};